export default __webpack_public_path__ + "static/media/a024-3.e35468a3.svg";